import React from 'react';

const ForgotUsernamePage = () => {
  return (
    <div className="occu-form">
      <h5>Your username is your email.</h5>
    </div>
  );
};

export default ForgotUsernamePage;
